/*jshint esversion: 6 */
// import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}MaterialEditor`,
    path: ':material_id',
    folder: 'WorkBenchRework',
    file: 'WorkBenchMaterialEditor',
    auth:true,
    props: (route) => {
      return {
        read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
        create: route.params.material_id === 'create'?true:false,
        location: payload.location,
        material_id: route.params.material_id
      };
    }
  });
  return route;
}
export default Template;
